export default "__VITE_ASSET__D7pVf3mz__"